import { render, staticRenderFns } from "./AllLeadsTablePopup.vue?vue&type=template&id=60745446&lang=html"
import script from "./AllLeadsTablePopup.vue?vue&type=script&lang=js"
export * from "./AllLeadsTablePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports